export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: 'f68ac60', dateTime: 1766529539298 };